// src/components/Header/Header.js
import React, { useState, useEffect } from 'react';
import { Layout, Menu, Button, Drawer, Space, message } from 'antd';
import { 
  MenuOutlined, 
  PhoneOutlined, 
  MessageOutlined
} from '@ant-design/icons';
import './Header.css';

const { Header: AntHeader } = Layout;

const Header = ({ currentSection, scrollToSection }) => {
  const [visible, setVisible] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const phoneNumber = '+255766764387'; // Remove spaces for tel: link

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 10;
      setScrolled(isScrolled);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const showDrawer = () => {
    setVisible(true);
  };

  const onClose = () => {
    setVisible(false);
  };

  const handleMenuClick = (key) => {
    scrollToSection(key);
    setVisible(false);
  };

  const menuItems = [
    { 
      key: 'home', 
      label: 'Home',
      className: 'menu-item'
    },
    { 
      key: 'services', 
      label: 'Services',
      className: 'menu-item'
    },
    { 
      key: 'clients-partners', 
      label: 'Clients & Partners',
      className: 'menu-item'
    },
    { 
      key: 'about-us', 
      label: 'About Us',
      className: 'menu-item'
    },
    { 
      key: 'contact', 
      label: 'Contact',
      className: 'menu-item'
    },
  ];

  const handleQuoteClick = () => {
    scrollToSection('contact');
  };

  const handleCallClick = () => {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      // Mobile device - initiate call
      window.location.href = `tel:${phoneNumber}`;
    } else {
      // Desktop - copy number to clipboard
      navigator.clipboard.writeText(phoneNumber.replace('+', ''));
      message.success('Phone number copied to clipboard!');
    }
  };

  const handleMessageClick = () => {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      // Mobile device - open messaging app
      window.location.href = `sms:${phoneNumber}`;
    } else {
      // Desktop - copy number to clipboard
      navigator.clipboard.writeText(phoneNumber.replace('+', ''));
      message.success('Phone number copied to clipboard for messaging!');
    }
  };

  return (
    <AntHeader className={`ant-header-custom ${scrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <div className="header-content">
          {/* Logo */}
          <div className="logo" onClick={() => scrollToSection('home')} style={{ cursor: 'pointer' }}>
            <img src="/logo.png" alt="Nexusflow" className="logo-image" />
          </div>
          
          {/* Desktop Menu */}
          <div className="desktop-menu-container">
            <Menu 
              mode="horizontal" 
              items={menuItems.map(item => ({
                ...item,
                onClick: () => handleMenuClick(item.key)
              }))} 
              className="desktop-menu"
              selectedKeys={[currentSection]}
            />
          </div>

          {/* Header Actions */}
          <Space className="header-actions" size="middle">
            {/* Call Button */}
            <Button 
              type="text"
              icon={<PhoneOutlined />}
              className="header-action-btn call-btn"
              size="small"
              onClick={handleCallClick}
              title="Call Us"
            />

            {/* Get Quote Button */}
            <Button 
              type="primary" 
              icon={<MessageOutlined />}
              className="quote-btn"
              size="small"
              onClick={handleMessageClick}
              title="Message Us"
            >
              Get Quote
            </Button>

            {/* Mobile Menu Button */}
            <Button 
              type="text" 
              icon={<MenuOutlined />} 
              className="mobile-menu-btn"
              onClick={showDrawer}
            />
          </Space>
          
          {/* Mobile Drawer */}
          <Drawer
            title={
              <div className="drawer-header">
                <img src="/logo.png" alt="Nexusflow" className="drawer-logo" />
              </div>
            }
            placement="right"
            onClose={onClose}
            open={visible}
            bodyStyle={{ padding: 0 }}
            headerStyle={{ borderBottom: '1px solid #f0f0f0' }}
          >
            <Menu
              mode="vertical"
              items={menuItems.map(item => ({
                ...item,
                onClick: () => handleMenuClick(item.key)
              }))}
              selectedKeys={[currentSection]}
              style={{ borderRight: 0, padding: '16px 0' }}
            />
            
            {/* Mobile Contact Info */}
            <div className="mobile-contact-info">
              <div className="contact-item" onClick={handleCallClick} style={{cursor: 'pointer'}}>
                <PhoneOutlined />
                <span>+255 766 764 387</span>
              </div>
              <Button 
                type="primary" 
                block 
                className="mobile-quote-btn"
                onClick={() => {
                  handleMessageClick();
                  onClose();
                }}
              >
                <MessageOutlined />
                Get Quote
              </Button>
            </div>
          </Drawer>
        </div>
      </div>
    </AntHeader>
  );
};

export default Header;